import { resolveCssVar } from "@appretio/shared";
import { AgChartTheme } from "ag-charts-enterprise";
import { useMemo } from "react";
import { semanticThemeTokens } from "../..";
import { noData } from "../Chart.css";

const NO_DATA_TEXT = "No Data to Show";

export function useAgChartTheme(isLoading: boolean): AgChartTheme {
  const agChartTheme = useMemo<AgChartTheme>(
    () => ({
      palette: {
        fills: [
          resolveCssVar(semanticThemeTokens.chart.palette.fill[1]),
          resolveCssVar(semanticThemeTokens.chart.palette.fill[2]),
          resolveCssVar(semanticThemeTokens.chart.palette.fill[3])
        ],
        strokes: [
          resolveCssVar(semanticThemeTokens.chart.palette.stroke[1]),
          resolveCssVar(semanticThemeTokens.chart.palette.stroke[2]),
          resolveCssVar(semanticThemeTokens.chart.palette.stroke[3])
        ]
      },

      params: {
        foregroundColor: resolveCssVar(
          semanticThemeTokens.chart.foregroundColor
        ),
        backgroundColor: "transparent",
        chromeBackgroundColor: resolveCssVar(
          semanticThemeTokens.chart.chromeBackgroundColor
        ),
        chromeSubtleTextColor: resolveCssVar(
          semanticThemeTokens.chart.chromeSubtleTextColor
        ),
        textColor: resolveCssVar(semanticThemeTokens.chart.textColor),
        tooltipBackgroundColor: resolveCssVar(
          semanticThemeTokens.chart.tooltipBackground
        ),
        tooltipTextColor: resolveCssVar(
          semanticThemeTokens.chart.tooltipTextColor
        ),
        crosshairLabelBackgroundColor: resolveCssVar(
          semanticThemeTokens.chart.crosshairLabelBackgroundColor
        ),
        crosshairLabelTextColor: resolveCssVar(
          semanticThemeTokens.chart.crosshairLabelTextColor
        ),
        gridLineColor: resolveCssVar(semanticThemeTokens.chart.gridColor),
        borderColor: resolveCssVar(semanticThemeTokens.chart.gridColor)
      },

      overrides: {
        common: {
          title: {
            fontSize: 14,
            color: resolveCssVar(semanticThemeTokens.chart.textColor),
            textAlign: "left",
            spacing: 30
          },
          subtitle: {
            fontSize: 14,
            color: resolveCssVar(semanticThemeTokens.chart.textColor),
            textAlign: "center",
            spacing: 16
          },
          axes: {
            number: {
              label: {
                spacing: 8,
                avoidCollisions: true,
                fontSize: 12
              },
              title: {
                fontSize: 12,
                spacing: 16
              }
            }
          },

          overlays: {
            loading: { enabled: isLoading },
            noVisibleSeries: {
              renderer: () => {
                const element = document.createElement("div");
                element.className = noData;
                element.textContent = NO_DATA_TEXT;
                return element;
              }
            }
          },

          legend: {
            spacing: 16
          }
        }
      }
    }),
    [isLoading]
  );

  return agChartTheme;
}
